module.exports = __webpack_public_path__ + "img/na-inventory-assumptions-screen.0992c80e.png";